export const segmentActionButtons = (status, id, segmentType, handleActionClick) => {
  const actionButtons = [
    {
      icon: "visibility",
      onClick: () => handleActionClick("view"),
    },
  ];
  if (segmentType === "PLATFORM") {
    actionButtons.push({
      icon: "edit",
      onClick: () => handleActionClick("edit"),
    });
    actionButtons.push({
      icon: "delete",
      onClick: () => handleActionClick("delete"),
    });
  }
  return actionButtons;
};
